const getApiUrl = ()=>
{
    const socketurl: any = process.env.REACT_APP_NOT_SECRET_CODE;
    return socketurl;
};


export default getApiUrl;